/* eslint-disable react/no-array-index-key */
import onlineIcon from '../../assets/images/svg/circle-green.svg';
import './onlineDoctorAvailable.css';

function OnlineDoctorAvailable(props) {
  const { userImages, userShow } = props;
  return (
    <div className="onlineDoctorAvailable">
      {userImages.slice(0, userShow).map((user, index) => (
        <div key={index} className="userImage">
          <img src={user} alt="userImage" />
        </div>
      ))}
      <div>
        <img src={onlineIcon} alt="onlineIcon" className="onlineIcon" />
      </div>
    </div>
  );
}

export default OnlineDoctorAvailable;
